"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatformLoader = usePlatformLoader;
const utils_1 = require("@juvare/common-web-ui/utils");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const stores_1 = require("../stores");
const usePreloader_1 = require("./usePreloader");
const useUserClient_1 = require("./useUserClient");
function usePlatformLoader(params) {
    const user = (0, react_redux_1.useSelector)(getUser);
    const dispatch = (0, react_redux_1.useDispatch)();
    const userClient = (0, useUserClient_1.useUserClient)();
    const appContext = params.appContext ? react_1.default.useContext(params.appContext) : undefined; // will be removed in future
    const onStatelessReload = async () => {
        const result = await userClient.getUserState();
        if (JSON.stringify(result.state) !== JSON.stringify(user?.data?.state)) {
            dispatch(stores_1.platformSlice.actions.setUser(result));
        }
        return result;
    };
    const { status, onReload } = (0, usePreloader_1.usePreloader)({
        status: user?.status ?? 'initial',
        onLoad: () => {
            dispatch(stores_1.platformSlice.actions.setLoading());
            return userClient.getUserState();
        },
        onSuccess: (result) => {
            dispatch(stores_1.platformSlice.actions.setUser(result));
            appContext?.initState(result); // will be removed in future
        },
        onError: (error) => {
            dispatch(stores_1.platformSlice.actions.setError((0, utils_1.getErrorMessage)(error)));
        },
    });
    return {
        status: status === 'error' ? 'done' : status,
        onReload,
        onStatelessReload,
    };
}
function getUser(state) {
    return state.platform.user;
}
